module.exports = __webpack_public_path__ + "img/1604.5f203556.gif";